module.exports = __webpack_public_path__ + "static/media/ML.72f11e0d.svg";